import { getItemById as getFurnitureItemById } from './furnitureCatalog';
import { getStairItemById } from './stairsCatalog';
import { getCompassItemById } from './compassCatalog'; // Import kompasu

// Główna funkcja pobierająca element z dowolnego katalogu
export const getItemById = (id) => {
  // 1. Sprawdź w meblach
  let item = getFurnitureItemById(id);
  if (item) return item;

  // 2. Sprawdź w schodach
  item = getStairItemById(id);
  if (item) return item;

  // 3. Sprawdź w różach wiatrów
  item = getCompassItemById(id);
  if (item) return item;

  return null;
};